import { arrayOf, objectOf, shape, string, bool } from 'prop-types';

export const unitAllotmentTypes = shape({});

export const purchaseOptionTypes = shape({});

export const departmentTypes = shape({
  departmentName: string,
  departmentNumber: string,
  billable: string,
  allotment: string,
  remainingAllotment: string,
  spentAllotment: string,
  lockedAllotment: string,
  currencyCode: string,
  purchaseOptions: arrayOf(purchaseOptionTypes),
  unitAllotments: arrayOf(unitAllotmentTypes),
  hasFutureAllotments: bool
});

export const newDepartmentTypes = shape({
  departmentName: string,
  billable: bool,
  allotment: string,
  remainingAllotment: string,
  spentAllotment: string,
  lockedAllotment: string,
  currencyCode: string,
  purchaseOptions: arrayOf(purchaseOptionTypes),
  unitAllotments: arrayOf(unitAllotmentTypes)
});

export const selectDepartmentTypes = shape({
  code: string.isRequired,
  currentRemaining: string,
  futureRemaining: string,
  futureBalanceRemaining: string,
  hasNextContract: bool,
  name: string.isRequired,
  number: string.isRequired
});

export const allotmentTypes = shape({
  allotedFunds: string,
  unAllotedFunds: string,
  compAccountNumber: string,
  totalAllotment: string,
  totalSpentAllotment: string,
  currencyCode: string,
  departments: arrayOf(departmentTypes)
});

export const newAllotmentTypes = shape({
  current: bool,
  allotedFunds: string,
  unallotedFunds: string,
  totalAllotment: string,
  totalSpentAllotment: string,
  currencyCode: string,
  departments: objectOf(newDepartmentTypes)
});
